import React from "react";
import {Bookmark, BookmarkBorder, LinkSharp, WhatsApp} from "@material-ui/icons";
import {Instagram, Phone, PhoneCall, Share2} from "react-feather";
import {Col, NavLink, Row} from "reactstrap";
import {GrLocation} from 'react-icons/gr'
import Technical from "../../../assets/img/logo/Technical professional.png";
import logo from '../../../assets/img/logo/logo4.webp'
import {IoShareSocial} from 'react-icons/io'
import CoursesHome from "../coursesHome/CoursesHome";
import {GetRequest} from "../../request";
import Notify from "../../Baran/noty/notify";
import {connect} from "react-redux";
import {GoBook} from 'react-icons/go'
import {history} from "../../../history";
import {MdLocationOn} from "react-icons/md";

class Footer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            whatsapp: false,
            enamad: true,
            footer_data: this.props.UI.footer_data
        }
    }

    support = () => {
        this.setState({
            whatsapp: !this.state.whatsapp,
            footer_data: !this.state.footer_data
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((this.props.UI !== prevProps.UI)) {
            this.setState({
                footer_data: this.props.UI.footer_data
            })
        }

    }


    render() {
        // console.log(this.state.footer_data)

        return (
            <>

                <div className='web-footer-top'>

                    <div className='footer-top row'>
                        <div className='footer-top-location col'>
                            <div className="d-flex box-social">
                                <p className="">
                                    <MdLocationOn size={15} className='ml-1'/>
                                    کرج گوهردشت ابتدای خیابان دوم غربی(ناجی پور) جنب سینما ساویز پلاک17 مجتمع ساویز
                                    طبقه5
                                </p>
                            </div>

                        </div>
                        <div className="d-flex col footer-top-phones p-0">
                            <div className="d-flex w-75 justify-content-center flex-wrap    ">
                                <div className="phones">
                                    <a className='mr-1 font-medium-1' href="tel:+989386393673">
                                        09386393673
                                        <Phone size={15} className=''/>
                                    </a>
                                </div>
                                <div className="phones">
                                    <a className='mr-1' href="tel:02634415888">
                                        02634415888
                                        <Phone size={15} className=''/>
                                    </a>
                                </div>
                            </div>

                            <div className='logo-footer-container w-25'>
                                <img src={logo} alt='کندو' loading='lazy'/>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="web-footer">
                    <div className="bg-black-footer">
                        <Row className="p-1 w-100">
                            <Col sm={12} md={3}>
                                <div className="box-for-footer box-for-footer-text">
                                    <div className="about-us-box d-flex">
                                        <LinkSharp/>
                                        <h3>
                                            درباره ما
                                        </h3>
                                    </div>
                                    <p className="social-text pt-1 text-justify">
                                        <a href="/"><strong>آموزشگاه آشپزی و شیرینی‌پزی کندو</strong></a>، که در کرج تحت
                                        مدیریت سرکار خانم سودابه حکیم
                                        الهی می باشد، از سال 1377 تأسیس شده است، با افتخار به دستاوردهای فراوانی دست
                                        یافته است. هم اکنون، ما با افتخار میزبان شما عزیزان، علاقه‌مندان به هنر آشپزی،
                                        در آموزشگاه کندو هستیم. مربیان ما با تخصص خود به شما آموزش می‌دهند تا بتوانید
                                        مهارت خود را در این حوزه بهبود بخشید. هنر <a
                                        href="/courses/1402-5-18-آشپزی"><strong>آشپزی</strong></a> و <a
                                        href="/courses/1402-5-18-شیرینی-پز-درجه-۱"><strong>شیرینی پزی درجه
                                        یک</strong></a> هنر بسیار ظریف، جذاب و محبوب
                                        است که علاقه مندان به آشپزی را به خود جذب می‌کند.
                                    </p>
                                </div>
                            </Col>
                            <Col sm={12} md={3}>
                                <div className="box-for-footer">
                                    <div className="about-us-box d-flex">
                                        <LinkSharp/>
                                        <h3>
                                            لینک های سریع
                                        </h3>
                                    </div>
                                    <div className="social-box d-flex flex-column flex-wrap pt-1">
                                        <div>
                                            <a href="https://behdasht.gov.ir/" target="_blank">وزارت بهداشت</a>
                                        </div>
                                        <div>
                                            <a href="https://www.fda.gov.ir/" target="_blank">سازمان غذا و دارو</a>
                                        </div>
                                        <div>
                                            <a href="https://irantvto.ir/" target="_blank">سازمان فنی حرفه ای</a>
                                        </div>
                                        <div>
                                            <a href="/contact-us" target="_blank">تماس با ما</a>
                                        </div>
                                        <div>
                                            <a href="/about-us/" target="_blank">درباره ما</a>
                                        </div>
                                        <div>
                                            <a href="/articles" target="_blank">مقالات</a>
                                        </div>
                                        <div>
                                            <a href="/gallery" target="_blank">گالری</a>
                                        </div>
                                        <div>
                                            <a href="/courses/1402-5-18-آشپزی-ملل" target="_blank">آشپزی بین المللی</a>
                                        </div>
                                        <div>
                                            <a href="/courses/1402-5-18-کباب-زن-و-تخته-کار" target="_blank">کباب زنی و
                                                تخته کاری</a>
                                        </div>
                                        <div>
                                            <a href="/courses/1402-5-18-شیرینی-پز-درجه-۱" target="_blank">شیرینی پزی
                                                درجه یک</a>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col sm={12} md={3}>
                                <div className="box-for-footer">
                                    <div className="about-us-box d-flex">
                                        <BookmarkBorder/>
                                        {/*<LocationCity/>*/}
                                        <h3>دوره ها</h3>
                                    </div>

                                    <p className="mt-1 font-medium-1">
                                        {(this.state.footer_data && this.state.footer_data?.courses.length > 0) ?
                                            this.state.footer_data?.courses.map((item, index) => {
                                                return (
                                                    <p onClick={() => history.push(`/course/${item.slug}`)}
                                                       className='footer-data'>{item.name}</p>
                                                )
                                            }) : <p>دوره ای وجود ندارد</p>

                                        }

                                    </p>
                                </div>

                                <div className="box-for-footer mt-3">
                                    <div className="about-us-box d-flex">
                                        <Share2/>
                                        {/*<LocationCity/>*/}
                                        <h3>شبکه های اجتماعی</h3>
                                    </div>

                                    <p className="mt-1 font-medium-1"> کرج گوهردشت ابتدای خیابان دوم غربی(ناجی پور) جنب
                                        سینما ساویز پلاک17 مجتمع ساویز طبقه5
                                    </p>
                                    <div className="social-box d-flex justify-content-center">
                                        <NavLink href="https://www.instagram.com/kandoo.academy/"
                                                 aria-label="اینستاگرام کندو"
                                                 className="my-auto" target="_blank">
                                            <Instagram size={28} className="mr-1 my-auto"/>
                                        </NavLink>
                                        <NavLink
                                            href="https://api.whatsapp.com/send/?phone=9386393673&text&app_absent=0"
                                            aria-label="واتساپ کندو"
                                            className="my-auto"
                                            target="_blank">
                                            <WhatsApp className="mr-1 my-auto"/>
                                        </NavLink>
                                    </div>
                                </div>

                            </Col>
                            <Col sm={12} md={3} className="">
                                <div className="box-for-footer1">
                                    {/*<div className="about-us-box d-flex">*/}
                                    {/*    <Share2/>*/}
                                    {/*    <h3>*/}
                                    {/*        اعتماد*/}
                                    {/*    </h3>*/}
                                    {/*</div>*/}
                                    <div
                                        className=" flex-column d-flex pt-1 justify-content-between align-items-center logo-continer">
                                        {/*<div className="m-auto logos">*/}
                                        {/*    <div>*/}
                                        {/*        <div className="logo">*/}
                                        {/*            <a referrerPolicy="origin" target="_blank"*/}
                                        {/*               href="https://trustseal.enamad.ir/?id=337703&amp;Code=aimBcfHI95pEUbuilCzX">*/}
                                        {/*                <img*/}
                                        {/*                    referrerPolicy="origin"*/}
                                        {/*                    src="https://Trustseal.eNamad.ir/logo.aspx?id=337703&amp;Code=aimBcfHI95pEUbuilCzX"*/}
                                        {/*                    alt="" style={{cursor: "pointer"}}*/}
                                        {/*                    id="aimBcfHI95pEUbuilCzX"/>*/}
                                        {/*            </a>*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*    /!*<div>*!/*/}
                                        {/*    /!*    <div className="logo">*!/*/}
                                        {/*    /!*        <img src={logo} alt="صنایع غذایی ندا"/>*!/*/}
                                        {/*    /!*    </div>*!/*/}
                                        {/*    /!*</div>*!/*/}
                                        {/*</div>*/}
                                        <div>
                                            <div className="logo">
                                                <img src={Technical} alt="سازمان فنی حرفه ای"/>
                                            </div>
                                        </div>
                                        <div>
                                            <a referrerPolicy="origin" target="_blank"
                                               href="https://trustseal.enamad.ir/?id=368702&amp;Code=JfXriy90FjxjBXHc5amn">
                                                <img
                                                    referrerPolicy="origin"
                                                    id="sLuBDa2yr3l6AoafaRdq"
                                                    src="https://trustseal.enamad.ir/Content/Images/Star2/30.png?v=5.0.0.3777"
                                                    alt="image" style={{cursor: "pointer"}}
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            {/*                            <Col sm={12} md={3}>
                            <div className="address-box d-flex">
                                <h3> اعتبار </h3>
                            </div>
                            <div className="d-flex justify-content-center">
                                {this.state.enamad ?
                                    <div>
                                        <a referrerPolicy="origin" target="_blank"
                                           href="https://trustseal.enamad.ir/?id=368702&amp;Code=JfXriy90FjxjBXHc5amn">
                                            <img
                                                referrerPolicy="origin"
                                                id="sLuBDa2yr3l6AoafaRdq"
                                                src="https://Trustseal.eNamad.ir/logo.aspx?id=368702&amp;Code=JfXriy90FjxjBXHc5amn"
                                                alt="" style={{cursor: "pointer"}}
                                            />
                                        </a>
                                    </div> : null}
                                <div>
                                </div>
                            </div>
                        </Col>*/}
                        </Row>
                    </div>
                    <div className="copyright p-1 w-100 m-auto">
                        <p className="m-0 signature">
                            کلیه حق و حقوق وبسایت برای <br/> <strong>آموزشگاه صنایع غذایی کندو</strong> محفوظ است
                        </p>
                        <p className="m-0">
                            {'این وبسایت توسط شرکت باران | '}
                            <a href="https://barantm.com/landing/educational-website-design">
                                <strong className='text-bold'>
                                    طراحی سایت آموزشی
                                </strong>
                            </a>
                            {' طراحی و تولید شده است.'}
                        </p>
                    </div>
                </div>

            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        UI: state.UI
    }
}

export default connect(mapStateToProps)(Footer)
